/**
 * Rounds a number to a specified pre-decimal place.
 * Examples:
 * - roundPreDecimals(123, 0) -> 100
 * - roundPreDecimals(11933, 1) -> 12000
 * - roundPreDecimals(72342, 2) -> 72300
 * - roundPreDecimals(123456, 3) -> 123500
 * @param value Numerical value to round
 * @param index Zero-based position from left after which to round
 * @returns rounded integer value
 */
export const roundPreDecimals = (value: number, index: number): number => {
  const numDigits = Math.round(value).toString().length;
  const roundBase = Math.pow(10, numDigits - index - 1);
  return Math.round(value / roundBase) * roundBase;
};
